<template>
    <div class="wrapper">
        <page-header></page-header>
        <div class="content_bg">
            <div class="content_main">
                <h3 class="line_blue">用户管理</h3>
                <div class="main_panel">
                    <div class="tool_panel">
                        <div class="tool_panel_right">
                            <div class="search">
                                <input type="text" placeholder="请输入" v-model="searchUser" @keyup.enter="search()">
                                <img src="../../assets/search_icon.png" alt="" v-on:click="search()">
                            </div>
                            <button class="btn btn_small btn_color_normal" v-on:click="add()">新增用户</button>
                        </div>
                    </div>
                    <div class="table_panel">
                        <div class="table_header">
                            <ul>
                                <li>用户名</li>
                                <li>角色</li>
                                <li>部门</li>
                                <li>操作</li>
                            </ul>
                        </div>
                        <div class="table_content">
                            <ul>
                                <li class="one_line" v-for="(item,index) in userList">
                                    <ul>
                                        <li>{{item.username}}</li>
                                        <li>{{item.description}}</li>
                                        <li>{{item.accountName}}</li>
                                        <li>
                                            <img src="../../assets/edit.png" alt="" v-on:click="editUser(item)">
                                            <img src="../../assets/delete.png" alt="" v-on:click="toDeleteUser(item,index)">
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <pagination v-if="pageStatus" v-bind:nums="numberLength" @setPage="gotoPage(arguments)" ref="Pagination"></pagination>
            </div>
        </div>
        <footer class="footer">
            <button class="btn btn_bg" v-on:click="toMainPage()">返回主界面</button>
        </footer>
        <add-user v-on:listentoChild="addOneUser" v-if="!!addUserStatus" v-bind:userData="currentUserData" v-bind:editstatus="ifEdit"></add-user>
        <tip v-if="ifShow  && sendMessage.length > 0" v-bind:status="sendStatus" v-bind:message="sendMessage"></tip>
        <div v-if="ifShowAlert" class="confirm">
          <div class="content">
            <div class="title">
              <span>删除用户</span>
            </div>
            <div class="text">确认删除用户{{userName}}吗？</div>
            <div class="btn_line">
              <button class="btn btn_color" v-on:click="sure()">确认</button>
              <button class="btn btn_cancel" v-on:click="cancel()">取消</button>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/common/PageHeader";
import AddUser from "@/components/common/addUser";
import Tip from "@/components/common/tip";
import Pagination from "@/components/common/Pagination";
import { mapState, mapActions } from "vuex";
import { getUserList, addUser, editOneUser, deleteUser } from "../../util/api.js";

export default {
  name: "User",
  components: {
    AddUser,
    PageHeader,
    Tip,
    Pagination
  },
  data() {
    return {
      currentUserData: {},
      ifEdit: false,
      searchUser: "",
      sendStatus: false,
      sendMessage: "",
      copyParameterList: [],
      pageStatus: false,
      currentPageSize:10,
      currentIndex:1,
      userName:'',
      ifShowAlert:false,
      userItem:{},
      userIndex:'',
      wrongMessage:{
          "-2": "无法删除自己",
          "-99": "用户信息不能为空",
          "-98": "用户密码不能为空",
          "-97": "该用户不存在",
          "-96": "不符合强密码规则",
          "-1": "该用户已存在"
        }
    };
  },
  computed: mapState({
    addUserStatus: state => state.addUserStatus,
    userList: state => state.userList,
    ifShow: state => state.ifShowMessage,
    messageDetail:state => state.errorMessage,
    numberLength:state => state.userLength
  }),
  mounted: function() {
    let that = this;
    that.$store.commit("getIfShowMessage", false);
    that.getList();
  },
  methods: {
    getCookie: function(name) {
      var arr;
      var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    add: function() {
      this.currentUserData = {
        username: "",
        role: "",
        external: "1",
        email: "",
        accountName: "",
        password: ""
      };
      this.$store.commit("openAddUser");
      this.ifEdit = false;
    },
    editUser: function(item) {
      this.currentUserData = item;
      this.ifEdit = true;
      this.$store.commit("openAddUser");
    },
    toDeleteUser:function(item, index){
      this.ifShowAlert = true;
      this.userItem = item;
      this.userIndex = index;
    },
    deleteUser: function(item, index) {
      let that = this;
      let adminId = that.getCookie('rstuserId');
      this.userName = item.username;
      if(adminId == item.id){
        that.$store.commit("getIfShowMessage", true);
        that.sendStatus = false;
        that.sendMessage = "管理员不能删除自己";
        return;
      }
      deleteUser({ id: item.id }).then(function(res) {
        that.$store.commit("getIfShowMessage", true);
        if(res.data){
          console.log(res);
          that.copyParameterList.splice((that.currentIndex-1)*that.currentPageSize+index, 1);
          let start = (that.currentIndex-1)*that.currentPageSize;
          let end = that.currentIndex*that.currentPageSize;
          if(that.copyParameterList.length <= start){
            start = (that.currentIndex-2)*that.currentPageSize;
            end = (that.currentIndex-1)*that.currentPageSize;
          }
          that.$store.commit(
            "getUserList",
            that.copyParameterList.slice(start, end)
          );
          that.$store.commit("getUserLength", that.copyParameterList.length);
          that.$refs.Pagination.getPageList();
          that.sendStatus = true;
          that.sendMessage = "删除用户成功";
        }else{
          that.sendStatus = false;
          that.sendMessage = "删除用户失败";
        }
      });
    },
    search: function() {
      let that = this;
      getUserList({username:this.searchUser})
        .then(function(res) {
          //that.$store.commit("getUserList", res.data);
          that.pageStatus = true;
          that.copyParameterList = JSON.parse(JSON.stringify(res.data));
          that.$store.commit(
            "getUserList",
            that.copyParameterList.slice(0, 10)
          );
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    toMainPage: function() {
      this.$router.push("/settingDays");
    },
    gotoPage: function(page) {
      console.log(page[0], page[1]);
      console.log(this.copyParameterList.slice(page[0], page[1]));
      this.$store.commit(
        "getUserList",
        this.copyParameterList.slice(page[0] - 1, page[1])
      );
      this.currentPageSize = page[2];
      this.currentIndex = page[3];
    },
    getList:function(){
      let that = this;
      getUserList()
      .then(function(res) {
        if (res.data) {
          that.pageStatus = true;
          that.copyParameterList = JSON.parse(JSON.stringify(res.data));
          let start = (that.currentIndex-1)*that.currentPageSize;
          let end = that.currentIndex*that.currentPageSize;
          if(that.copyParameterList.length < start){
            start = 0;
            end = that.currentPageSize;
          }
          that.$store.commit(
            "getUserList",
            that.copyParameterList.slice(start, end)
          );
          that.$store.commit("getUserLength", that.copyParameterList.length);
          if(that.$refs && that.$refs.Pagination){
            that.$refs.Pagination.getPageList();
          }
          console.log(that.copyParameterList);
        } else {
          that.$store.commit("getIfShowMessage", true);
          that.sendStatus = false;
          that.sendMessage = "获取用户列表失败";
        }
      });
    },
    addOneUser:function(send){
      console.log(send);
      let that = this;
      if(send.success){
        if(!!send.data['id']){
          editOneUser(send.data)
          .then(function(res){
            that.$store.commit("getIfShowMessage", true);
            if(res.data.success){
              that.sendStatus = true;
              that.sendMessage = "修改用户成功";
              that.getList();
            }
            else{
              that.sendStatus = false;
              that.sendMessage = that.wrongMessage[res.data.id];
            }
          })
        }else{
          addUser(send.data)
          .then(function(res){
            that.$store.commit("getIfShowMessage", true);
            if(res.data.success){
              that.sendStatus = true;
              that.sendMessage = "新增用户成功";
              that.getList();
            }
            else{
              that.sendStatus = false;
              that.sendMessage = that.wrongMessage[res.data.id];
            }
          })
        }
      }else{
        that.$store.commit("getIfShowMessage", true);
        that.sendStatus = false;
        that.sendMessage = "两次密码不一致";
      }
      
    },
    sure:function(){
      this.ifShowAlert = false;
      this.deleteUser(this.userItem, this.userIndex);
    },
    cancel:function(){
      this.ifShowAlert = false;
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  min-width: 657px;
}
.btn {
  width: 1.88rem;
  height: 0.46rem;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
}
.btn_small {
  width: 1.06rem;
  height: 0.36rem;
  cursor: pointer;
}
.btn_bg {
  background-color: #fa5400;
  color: #fff;
}
.content_bg {
  background-color: #f7f7f7;
  padding-top: 0.3rem;
  margin-bottom: 0.77rem;
}
@media screen and (max-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 6.54rem;
      margin: 0 auto;
      padding-top: 0.15rem;
      box-shadow: 0 0 5px -3px #000;
    }
}
@media screen and (min-height: 650px) {
    .content_main {
      background-color: #fff;
      width: 10rem;
      height: 6.54rem;
      margin-top: -0.1rem;
      padding-top: 0.15rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      box-shadow: 0 0 5px -3px #000;
    }
}
.content_main h3 {
  text-align: left;
}
.line_blue:before {
  display: inline-block;
  width: 0.04rem;
  height: 0.24rem;
  vertical-align: middle;
  content: "";
  margin-right: 10px;
  background-color: #0a8cd1;
}
.main_panel {
  padding: 0 0.23rem;
}
.tool_panel {
  overflow: hidden;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}
.tool_panel_right {
  float: right;
  display: flex;
}
.search img {
  position: relative;
  left: -0.37rem;
  vertical-align: middle;
  cursor: pointer;
}
.search input {
  width: 2.48rem;
  height: 0.36rem;
  border: 1px solid #d8d8d8;
  padding-left: 0.19rem;
  line-height: 0.36rem;
  font-size: 0.15rem;
  border-radius: 2px;
}
.btn_color_normal {
  border: 1px solid #000;
  color: #000;
  font-size: 0.15rem;
  background-color: #fff;
}
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.table_panel {
  overflow: auto;
}
.table_header {
  line-height: 0.45rem;
  overflow: hidden;
  background-color: #eeeeee;
}
.table_header li,
.one_line li {
  width: 2.38rem;
  padding-left: 0.2rem;
  font-size: 0.15rem;
  float: left;
  border-left: 3px solid #fff;
  text-align: left;
}
.table_header li:last-child {
  width: auto;
}
.table_content {
  overflow: auto;
  height: 4.5rem;
}
.one_line ul {
  line-height: 0.45rem;
  overflow: hidden;
}
.one_line:nth-child(n) ul {
  background-color: #fff;
}
.one_line:nth-child(2n) ul {
  background-color: #f7f7f7;
}
.one_line li:last-child {
  width: auto;
}
.one_line img {
  margin-right: 0.12rem;
  cursor: pointer;
}
.footer {
  height: 0.66rem;
  background-color: #000;
  box-shadow: 0 10px 25px #000;
  position: fixed;
  bottom: 0;
  width: 100%;
  line-height: 0.66rem;
}
.confirm{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0006;
}
.confirm .content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 360px;
    height: 200px;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    background-color: #fff;
}
.confirm .title{
    height: 40px;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    background: #eeeeee;
    font-weight: bold;
}
.confirm .text{
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
.btn_line .btn{
    width: 70px;
    height: 30px;
    border: 0;
    border-radius: 2px;
    color: #fff;
    margin-left: 10px;
}
.btn_line .btn_color{
  background-color: #fa5400;
}
.btn_line .btn_cancel{
  background-color: #eee;
}
</style>




// WEBPACK FOOTER //
// src/components/page/User.vue